import { render, staticRenderFns } from "./InkjetAddPriceModel.vue?vue&type=template&id=669ae0f7&"
import script from "./InkjetAddPriceModel.ts?vue&type=script&lang=js&"
export * from "./InkjetAddPriceModel.ts?vue&type=script&lang=js&"
import style0 from "./InkjetAddPriceModel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports